"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/** @ignore */

function fetchPrivate(input, init) {
  init = init || {};
  init.referrerPolicy = 'no-referrer';
  return fetch(input, init);
}

exports.fetchPrivate = fetchPrivate;